import axios from 'axios';
import tools from './tools';

// List all course per university
async function listAssignments(courseId, lessonId, queryParams, cancelTokenParam ) {  
  queryParams = queryParams || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();
  
  const fields = queryParams.fields || "id";
  const expand = queryParams.expand;
  const ordering = queryParams.ordering || "name";
  const limit = queryParams.limit || process.env.REACT_APP_DEFAULT_LIMIT_PAGINATION; //'no_paginate';
  const offset = queryParams.offset || 0;
  const assignment_type = "GENERAL";

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/courses/${courseId}/lessons/${lessonId}/assignments/`;

  const request = axios.get(url, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    params: {
      fields,
      expand,
      ordering,
      limit,
      offset,
      assignment_type
    },
    cancelToken: cancelToken.token 
  });
  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function retrieveLesson(courseId, id, queryParams, cancelTokenParam ) {  
  queryParams = queryParams || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();
  
  const fields = queryParams.fields || "id";
  const expand = queryParams.expand;
  const ordering = queryParams.ordering || "name";
  const limit = queryParams.limit || process.env.REACT_APP_DEFAULT_LIMIT_PAGINATION; //'no_paginate';
  const offset = queryParams.offset || 0;


  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/courses/${courseId}/lessons/${id}/`;

  const request = axios.get(url, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    params: {
      fields,
      expand,
      ordering,
      limit,
      offset
    },
    cancelToken: cancelToken.token 
  });
  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function createAssignment(courseId, lessonId, bodyData, cancelTokenParam ) {
  bodyData = bodyData || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/courses/${courseId}/lessons/${lessonId}/assignments/`;  
  const request = axios.post(url, bodyData, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    cancelToken: cancelToken.token 
  });
  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function updateAssignment(courseId, lessonId, bodyData, cancelTokenParam ) {
  bodyData = bodyData || {}; 
  const cancelToken = cancelTokenParam || axios.CancelToken.source();

  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/courses/${courseId}/lessons/${lessonId}/assignments/${bodyData.id}/`;  
  const request = axios.patch(url, bodyData, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    cancelToken: cancelToken.token 
  });
  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}

async function deleteAssignment(courseId, lessonId, assignmentId, cancelTokenParam ) {    
  const cancelToken = cancelTokenParam || axios.CancelToken.source();
  var url = `${tools.getBaseHost()}/universities/${tools.getUserData().university}/courses/${courseId}/lessons/${lessonId}/assignments/${assignmentId}/`;  
  const request = axios.delete(url, {
    headers: { 
      Authorization: `Bearer ${tools.getUserData().token}`,
      Timezone: tools.getTimezone()
    },
    cancelToken: cancelToken.token 
  });
  request.catch(error => {
    tools.checkResponseStatus(error);
  });
  return request;
}


export default {
  listAssignments,
  retrieveLesson,
  createAssignment,
  updateAssignment,
  deleteAssignment
}